// Mercapoli - Blog
import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { ArrowLeft, Calendar, ArrowRight } from 'lucide-react';
import { Button } from '../../components/ui/button';
import Footer from '../../components/Footer';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_mercadelivery-1/artifacts/5y038jeg_icono_mercapoli.png";

const Blog = () => {
  // Placeholder para futuros artículos
  const articulos = [
    {
      titulo: "Bienvenidos al Blog de Mercapoli",
      fecha: "Enero 2026",
      resumen: "Conoce las últimas noticias, lanzamientos y novedades de nuestra plataforma.",
      categoria: "Anuncios"
    },
    {
      titulo: "Próximamente: Nuevas funcionalidades",
      fecha: "Enero 2026", 
      resumen: "Estamos trabajando en mejoras increíbles para comercios y repartidores.",
      categoria: "Novedades"
    }
  ];

  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>Blog Mercapoli | Noticias y actualizaciones</title>
        <meta name="description" content="Conoce las últimas noticias, lanzamientos y novedades de Mercapoli." />
      </Helmet>

      {/* Header */}
      <header className="border-b border-border">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center gap-2">
              <img src={LOGO_URL} alt="Mercapoli" className="w-10 h-10" />
              <span className="font-heading text-xl font-bold">Mercapoli</span>
            </Link>
            <Link to="/">
              <Button variant="ghost" size="sm">
                <ArrowLeft className="h-4 w-4 mr-2" />
                Volver
              </Button>
            </Link>
          </div>
        </div>
      </header>

      {/* Hero */}
      <section className="py-16 bg-gradient-to-b from-brand-primary/10 to-background">
        <div className="container mx-auto px-4 text-center">
          <h1 className="font-heading text-4xl md:text-5xl font-bold mb-6">
            Blog Mercapoli
          </h1>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            Noticias, actualizaciones y consejos para nuestra comunidad
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="py-16">
        <div className="container mx-auto px-4 max-w-4xl">
          <p className="text-lg text-center mb-12">
            Bienvenido al Blog de Mercapoli, el espacio donde compartimos noticias, lanzamientos, 
            mejoras de la plataforma, consejos y contenido relevante sobre delivery, logística y tecnología.
          </p>

          <div className="mb-8">
            <h2 className="font-heading text-xl font-bold mb-4">Aquí encontrarás:</h2>
            <ul className="list-disc list-inside space-y-2 text-muted-foreground">
              <li>Novedades de la plataforma</li>
              <li>Anuncios oficiales</li>
              <li>Consejos para repartidores</li>
              <li>Actualizaciones para comercios</li>
            </ul>
          </div>

          {/* Artículos */}
          <div className="space-y-6 mt-12">
            {articulos.map((articulo, index) => (
              <div key={index} className="p-6 rounded-2xl bg-card border border-border hover:border-brand-primary/50 transition-colors">
                <div className="flex items-center gap-2 text-sm text-muted-foreground mb-3">
                  <Calendar className="h-4 w-4" />
                  <span>{articulo.fecha}</span>
                  <span className="px-2 py-1 rounded-full bg-brand-primary/10 text-brand-primary text-xs">
                    {articulo.categoria}
                  </span>
                </div>
                <h3 className="font-heading text-xl font-bold mb-2">{articulo.titulo}</h3>
                <p className="text-muted-foreground mb-4">{articulo.resumen}</p>
                <Button variant="ghost" size="sm" className="text-brand-primary" disabled>
                  Próximamente <ArrowRight className="h-4 w-4 ml-2" />
                </Button>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Blog;
